import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { SEOText, MetaTags, StaticMetaTags, FAQ } from '@corefront/seo-tools';
import classNames from 'classnames';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import CanonicalLink from './CanonicalLink/CanonicalLink';
import MetaRobots from './MetaRobots/MetaRobots';
import { withSEOContent } from '../../hocs/withSEOContent';
import {
  useMetaTagsRequestUrl,
  useStaticMetaTagsRequestUrl,
} from './hooks/useMetaTagsRequestUrl';
import { useSEOTextRequestUrl } from './hooks/useSEOTextRequestUrl';
import { useFAQRequestUrl } from './hooks/useFAQRequestUrl';
import { useIsSSRMode } from '../../hooks/useIsSSRMode';
import { useIsSC } from '../../hooks/useIsSC';
import { useTranslationMetaTags } from './hooks/useTranslationMetaTags';
import { useSEOTextFormat } from './hooks/useSEOTextFormat';
import { useMetaTagsFormat } from './hooks/useMetaTagsFormat';
import { useSelectSpecificSEOData } from './hooks/useSelectSpecificSEOData';
import {
  isNativeSelector,
  isLoggedInSelector,
} from '../../redux/reducers/app/params';
import { ROOT } from '../../constants/routeTemplates';
import styles from './SEOWrapper.module.css';

const SEOWrapper = ({ withTopDivider }) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  const isSSR = useIsSSRMode();

  const translate = useTranslationMetaTags();
  const formatMetaTags = useMetaTagsFormat();

  const staticMetaTagsRequestUrl = useStaticMetaTagsRequestUrl();
  const metaTagsRequestURL = useMetaTagsRequestUrl();

  const selectSpecificSEOData = useSelectSpecificSEOData();

  return (
    <>
      <StaticMetaTags
        translate={translate}
        requestUrl={staticMetaTagsRequestUrl}
        format={formatMetaTags}
      />
      <MetaTags
        requestUrl={metaTagsRequestURL}
        translate={translate}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        format={formatMetaTags}
      />
      <CanonicalLink />
      <MetaRobots />
      {!isLoggedIn && (
        <SEOTextBlocks isSSR={isSSR} withTopDivider={withTopDivider} />
      )}
    </>
  );
};

export const SEOTextBlocks = ({ isSSR, withTopDivider }) => {
  const isNative = useSelector(isNativeSelector);
  const isSCCOM = useIsSC();
  const { path } = useRouteMatch();

  const formatSEOText = useSEOTextFormat();

  const SEOTextRequestURL = useSEOTextRequestUrl();
  const FAQRequestURL = useFAQRequestUrl();

  const selectSpecificSEOData = useSelectSpecificSEOData();

  const showBreadcrumbs = isSCCOM ? path !== ROOT && !isNative : !isNative;

  return (
    <div
      className={classNames(
        styles['lc-SEOWrapper'],
        withTopDivider && styles['lc-top-divider']
      )}
    >
      {showBreadcrumbs && <Breadcrumbs className={styles['lc-breadcrumbs']} />}

      <SEOText
        requestUrl={SEOTextRequestURL}
        collapsed={!isSSR}
        format={formatSEOText}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        className={styles['lc-seo-content']}
      />
      <FAQ
        requestUrl={FAQRequestURL}
        collapsed={!isSSR}
        format={formatSEOText}
        queryOptions={{
          select: selectSpecificSEOData,
        }}
        className={styles['lc-seo-content']}
      />
    </div>
  );
};

export default withSEOContent(SEOWrapper);
